import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';

//Context
import { useAuth } from '../../../../../context/auth';

//Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../../helpers/message';

//Components
import TextField from '../../../../../components/TextField';

//Api
import formulario_api from '../../../../../api/formulario_api';

export default function Identificacao({ formulario, setFormulario, loadFormulario, editavel }) {
    const { setLoading } = useAuth();

    //Estado de controle dos erros nos campos
    const [errors, setErrors] = useState({});

    //Função de onChange dos campos
    const onChange = (e) => {
        const { name, value } = e.target;
        setFormulario({
            ...formulario,
            [name]: value
        })
    }
    //Campos obrigatorios
    const camposIdentificacao = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "status", required: true })
    ]
    //Função que salva o formulario
    const salvarFormulario = () => {
        const _errors = validarCampos(formulario, camposIdentificacao);
        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return true;

        const _formulario = { ...formulario };

        setLoading(true);

        if (formulario.id) {
            formulario_api.putFormulario(_formulario).then(response => {
                showMessage("Sucesso", "Sucesso ao atualizar o formulario", "success", () => loadFormulario());
            }).catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            formulario_api.postFormulario(_formulario).then(response => {
                showMessage("Sucesso", "Sucesso ao cadastrar o formulario", "success", () => loadFormulario(response.data));
            }).catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        }

        return false;
    }

    return (
        <Row>
            <h5 className='mb-3'>Identificação do formulário</h5>
            <Col md="12" lg="8">
                <TextField
                    name={"identificacao"}
                    label={"* Identificação"}
                    value={formulario.identificacao}
                    invalid={!!errors.identificacao}
                    onChange={onChange}
                    disabled={!editavel} />
            </Col>
            <Col md="12" lg="4">
                <TextField
                    type={"select"}
                    label="* Finalidade"
                    name={"finalidade"}
                    options={
                        [
                            { label: "Processo", value: "Processo" },
                            { value: "Vistoria", label: "Vistoria" }
                        ]
                    }
                    onChange={onChange}
                    value={formulario.finalidade}
                    invalid={!!errors.finalidade}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="3">
                <TextField
                    type={"radio"}
                    label="* Status"
                    name={"status"}
                    options={
                        [
                            { label: "Ativo", value: "Ativo" },
                            { value: "Inativo", label: "Inativo" }
                        ]
                    }
                    onChange={onChange}
                    value={formulario.status}
                    invalid={!!errors.status}
                    disabled={!editavel}
                />
            </Col>
            {editavel &&
                <Col md="12" lg="12" className='d-flex align-items-center justify-content-center '>
                    <Button color='success' className='px-4' onClick={salvarFormulario}>
                        <FontAwesomeIcon icon={faSave} /> Salvar
                    </Button>
                </Col>
            }
        </Row>
    )
}